<template>
  <IframeCovid :locationListApi="locationListApi" :locationListHistory="locationListHistory"
    @onLocationinput="fetchLocations($event)" @onSearch="searchLocation" @onFocusSearch="hideBlockFilters"
    @onClearLocationHistory="clearHistory('loc_hst')"
    @onRemoveLocationItem="removeItemFromHistoryList($event, 'loc_hst')" />
</template>
<script>
import { ref } from 'vue';
import IframeCovid from '@/components/iframe/IframeCovid.component.vue';
import { useLocations } from '@/hooks/autocomplete.hook';
import { LocalStoragePlugin } from '@/plugins';

export default {
  components: {
    IframeCovid,
  },
  setup() {
    const locationListHistory = ref(
      (LocalStoragePlugin.get('loc_hst')?.split('|') || []).filter((elem) => !!elem),
    );
    function refreshHistory(key) {
      locationListHistory.value = (LocalStoragePlugin.get(key)?.split('|') || []).filter((elem) => !!elem);
    }

    function saveItemToLocalStorage(key, value) {
      const listSearchItems = LocalStoragePlugin.get(key)?.split('|') || [];
      if (!listSearchItems.includes(value) && !!value) { listSearchItems.push(value); }
      LocalStoragePlugin.set(key, listSearchItems.join('|'));
      refreshHistory(key);
    }

    function clearHistory(key = 'text_hst_d9') {
      LocalStoragePlugin.clear(key);
      refreshHistory(key);
    }
    function removeItemFromHistoryList(key, index) {
      const listSearchItems = LocalStoragePlugin.get(index)?.split('|') || [];
      const indexItemToremove = listSearchItems?.findIndex(
        (val) => key === val,
      );
      if (indexItemToremove !== -1) { listSearchItems.splice(indexItemToremove, 1); }
      if (listSearchItems.length < 1) {
        clearHistory(index);
      } else {
        LocalStoragePlugin.set(index, listSearchItems.join('|'));
      }
      refreshHistory(index);
    }

    const [locationListApi, fetchLocations] = useLocations();
    function searchLocation({ locationText }) {
      saveItemToLocalStorage('loc_hst', locationText);
      const bodySelector = document.querySelector('.page-node-type-iframe-dynamique');
      if (bodySelector) {
        window.Drupal.behaviors.santeIframeDynamic.locationSearch();
      } else {
        window.Drupal.behaviors.leafletIframe.searchLocator();
      }
    }
    function hideBlockFilters() {
      const blockFiltersElement = document.querySelector('.first-filters-collapse');
      const searchFilterBlock = document.querySelector('#search-filters');
      if (blockFiltersElement) searchFilterBlock.classList.remove('in');
      if (searchFilterBlock) blockFiltersElement.setAttribute('aria-expanded', false);
    }
    return {
      locationListApi,
      searchLocation,
      fetchLocations,
      hideBlockFilters,
      clearHistory,
      removeItemFromHistoryList,
      locationListHistory,
    };
  },
};
</script>
